import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../../components/table/SearchGrid';
import Breadcrums from '../../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../../../Services/APIService';
import Loader from '../../../../components/Loader/Loader';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../../components/Message/Alert";
import AddDistributer from './addDistributer/AddDistributer';



function DistributionList({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});

    const [openDistributer, setOpenDistributer] = useState(false);
    const [distributionList, setDistributionList] = useState([]);
    const [selectedListId, setSelectedListId] = useState(0);
    const OpenDistributer = () => {
        setSelectedListId(0);
        setOpenDistributer(true)
    }

    const CloseDistributer = () => {
        setOpenDistributer(false)
    }

    const editList = (item) => {
        setSelectedListId(item.listId);
        setOpenDistributer(true);
    }

    const deleteList = (record) => {
        showActionDialog("This distribution list will no longer be available for publication. Are you sure to delete it?", "confirm", function () {
            setIsLoading(true);
            var method = "fdndistributionlist/delete";

            PostDataAPI(method, record, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        var message = "Distribution list deleted";
                        handleSuccessClose(message);

                    }
                    else {
                        showMessage("Error", "Error deleting distribution list, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        });
    }

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const [state, setState] = useState({});

    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }


    const [filteredStatus, setFilteredStatus] = useState([]);


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };
    const loadDistributionList = () => {
        setIsLoading(true);
        var params = { category: 'PR' }
        PostDataAPI("fdndistributionlist/loadGrid", params).then((result) => {
            if (result.success && result.data) {
                setDistributionList(result.data);
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    const handleSuccessClose = (message) => {
        CloseDistributer();
        showMessage("Success", message, "success", 3000);
        loadDistributionList();
    }

    useEffect(() => {
        loadDistributionList();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            {/* <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Distribution List"} isBack={false}></Breadcrums>
                    </Grid>
                </Grid>
            </div> */}




            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => OpenDistributer()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}

                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid
                    columns="DistributerList"
                    list={distributionList}
                    noRecordMsg="No record exists"
                    Icon={true}
                    onEditClick={(item) => { editList(item) }}
                    onDeleteClick={deleteList}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                />
            </Grid>

            {openDistributer ?
                <AddDistributer
                    dialogOpenClose={OpenDistributer}
                    handleClose={CloseDistributer}
                    handleSuccessClose={handleSuccessClose}
                    selectedListId={selectedListId}
                ></AddDistributer>
                : ""}





            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(DistributionList);